import React from 'react';
import type { CarouselItemContent } from '../../template/imageCarouselTypes';
import ImageCarouselSlideImageZone from './ImageCarouselSlideImageZone';
import ImageCarouselSlideVideoZone from './ImageCarouselSlideVideoZone';
import type { useCardVideoUpload } from './useCardVideoUpload';

interface ImageCarouselSlideMediaZoneProps {
  index: number;
  item: CarouselItemContent;
  uploading: boolean;
  upload: ReturnType<typeof useCardVideoUpload>;
  getVideoPlaybackUrl: (externalId: string) => Promise<{ url: string }>;
  onFile: (file: File) => void;
  onVideoFile: (file: File) => void;
  onVideoUrl: (url: string) => void;
  onOpenLibrary: () => void;
}

/** A slide's media: the video zone (upload/transcode/playback states) or the image zone. */
export default function ImageCarouselSlideMediaZone({
  index,
  item,
  uploading,
  upload,
  getVideoPlaybackUrl,
  onFile,
  onVideoFile,
  onVideoUrl,
  onOpenLibrary,
}: ImageCarouselSlideMediaZoneProps) {
  if (item.isVideo) {
    return (
      <ImageCarouselSlideVideoZone
        index={index}
        item={item}
        phase={upload.phase}
        uploadProgress={upload.uploadProgress}
        asset={upload.asset}
        errorMessage={upload.errorMessage}
        getVideoPlaybackUrl={getVideoPlaybackUrl}
        onVideoFile={onVideoFile}
        onOpenLibrary={onOpenLibrary}
      />
    );
  }
  return (
    <ImageCarouselSlideImageZone
      index={index}
      imageUrl={item.imageUrl?.url}
      altText={item.altText?.content}
      uploading={uploading}
      onFile={onFile}
      onVideoFile={onVideoFile}
      onVideoUrl={onVideoUrl}
    />
  );
}
